import {
  put, call, all, select,
} from 'redux-saga/effects';

import { Creators as UiCreators } from '../ducks/ui';
import { apiGetTagsAndServicesByCity, apiGetServicesByCategory } from '../../services/api/services';
import { getCompanyId } from '../ducks/company';
import { Creators as CreatorsService } from '../ducks/services';
import { Creators as CreatorsCategory } from '../ducks/categories';

export function* getServicesByCity({ payload }) {
  try {
    yield put(UiCreators.showLoader('SERVICES'));
    let companyId = yield select(getCompanyId);

    if (!Object.keys(companyId).length) {
      companyId = 1;
    }
    const resp = yield call(apiGetTagsAndServicesByCity, companyId, payload.id);

    if (resp.success && resp.data) {
      yield put(CreatorsService.getServicesSuccess(resp.data.services));
      yield put(CreatorsCategory.getCategoriesSuccess(resp.data.categories));
      yield put(UiCreators.hideLoader('SERVICES'));
    }
  } catch (error) {
    yield all([put(UiCreators.hideLoader('SERVICES'))]);
  }
}

export function* getServicesByCategory({ payload }) {
  try {
    yield put(UiCreators.showLoader('SERVICES'));
    const props = yield select(state => state.company.data);
    const data = yield call(apiGetServicesByCategory, payload.categoryId, props.city_id);

    if (data.success) {
      yield put(CreatorsService.getServiceByCategorySuccess(data.services));
      yield put(UiCreators.hideLoader('SERVICES'));
    }
  } catch (error) {
    yield all([put(UiCreators.hideLoader('SERVICES'))]);
  }
}
